import React, { useState } from "react";
import { Form, Input } from "antd";
import toast from "react-hot-toast";
import { SetMpinApi } from "../../api/request/users";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUserDetails, setloggedIn } from "../../store/Slices/userSlice";
import { setCookies } from "../../services/Cookies.jsx";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import ConfirmationModal from "../../components/modals/ConfirmationModal.jsx";

function SetMpin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mpin, setMpin] = useState("");
  const [confirmMpin, setConfirmMpin] = useState("");

  const finishLogin = (data) => {
    setCookies("token", data?.data?.access_token);
    dispatch(setloggedIn(true));
    const user = data?.data;
    delete user?.access_token;
    dispatch(setUserDetails(user));
    navigate("/dashboard");
  };

  const handleSubmit = async (allowMutiLogin) => {
    if (!localStorage.getItem("userId")) {
      toast.error("Login session expired. Please login again.");
      navigate("/");
      return;
    }
    if (!mpin || mpin.length < 6 || !confirmMpin || confirmMpin.length < 6) {
      toast.error("Enter a 6-digit MPIN in both fields.");
      return;
    }
    if (mpin !== confirmMpin) {
      toast.error("MPIN and confirm MPIN do not match.");
      return;
    }
    try {
      setIsLoading(true);
      const { data } = await SetMpinApi({
        userId: localStorage.getItem("userId"),
        mpin,
        confirmMpin,
        loginType: "web",
        allowMutiLogin: !!allowMutiLogin,
      });
      if (data?.error?.foundMultipleLogin) {
        setIsOpen(true);
      } else {
        finishLogin(data);
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message || "Something went wrong");
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="min-h-screen flex items-center justify-center bg-[#f9f9f9]" style={{ backgroundImage: "url('/assets/images/authbg.png')", backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
        <div className="rounded-2xl shadow-xl bg-[#FFFFFF]">
          <div className="flex flex-col justify-center items-center px-10 py-10 gap-6 w-full">
            <img src="/assets/logo/logo.png" alt="logo" className="h-10 w-48 object-contain" />
            <div className="text-center">
              <p className="text-[#2F2B3D] text-2xl font-semibold">Set MPIN</p>
              <p className="text-[silver] text-sm font-medium mt-2">Create a 6-digit MPIN. You will use it at every login.</p>
            </div>
            <Form className="w-full" autoComplete="off" onFinish={() => handleSubmit(false)}>
              <p className="text-sm text-[#585F70] mb-2">MPIN</p>
              <Form.Item name="mpin" rules={[{ required: true, message: "Enter your MPIN." }]}>
                <Input.OTP length={6} value={mpin} onChange={(value) => setMpin(typeof value === "string" ? value : "")} style={{ width: "100%" }} />
              </Form.Item>
              <p className="text-sm text-[#585F70] mb-2 mt-4">Confirm MPIN</p>
              <Form.Item name="confirmMpin" rules={[{ required: true, message: "Confirm your MPIN." }]}>
                <Input.OTP length={6} value={confirmMpin} onChange={(value) => setConfirmMpin(typeof value === "string" ? value : "")} style={{ width: "100%" }} />
              </Form.Item>
              <div className="mt-8">
                <LoadableButton type="submit" className="bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2" lable="Save and continue" isLoading={isLoading} loadingLable="Saving..." />
              </div>
              <div className="primary flex items-center justify-center mt-5 text-sm">
                <a href="/">Back to login</a>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <ConfirmationModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        message="User is already logged in on the website. Please log out before attempting to log in again."
        onConfirm={() => { setIsOpen(false); handleSubmit(true); }}
      />
    </>
  );
}

export default SetMpin;
